import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import RangeColorCreateEdit from 'src/views/Pages/Dashboard/RangeColor/RangeColorCreateEdit';
import RangeColors from 'src/views/Pages/Dashboard/RangeColor/RangeColors';

const RangeColorRoutes =
{
    path: 'rangecolorheaders',
    component: EmptyRouterView,
    children: [
        {
            path: '',
            name: 'common_words.color_range',
            component: RangeColors,
            meta: {
                prefix_permission: 'rangecolorheaders',
            },
        },
        {
            path: 'create',
            name: 'common_words.color_range',
            component: RangeColorCreateEdit,
            meta: {
                prefix_permission: 'rangecolorheaders',
            },
        },
        {
            path: 'edit',
            name: 'common_words.color_range',
            component: RangeColorCreateEdit,
            meta: {
                prefix_permission: 'rangecolorheaders',
            },
        },
    ],
};

export default RangeColorRoutes;